import React from 'react';
import { motion } from 'framer-motion';
import { Github, Twitter, Linkedin, Instagram, Heart, ArrowUp } from 'lucide-react';
import { companyData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Github, href: '#', label: 'GitHub' },
  ];

  return (
    <footer className="relative bg-slate-100/80 border-t border-slate-200 pt-16 pb-12 overflow-hidden">
      {/* Ambient Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-64 bg-purple-200/30 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Info */}
          <div className="md:col-span-2">
            <a href="#" className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-600 to-indigo-600 flex items-center justify-center text-white font-bold text-lg shadow-md">
                V
              </div>
              <span className="text-2xl font-bold font-display text-slate-900 tracking-tight">
                {companyData.name}
              </span>
            </a>
            <p className="text-slate-600 mb-6 max-w-md text-sm leading-relaxed">
              {companyData.description}
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-10 h-10 rounded-xl glass flex items-center justify-center text-slate-600 hover:text-purple-600 hover:border-purple-300 transition-all duration-200 shadow-sm"
                  aria-label={social.label}
                >
                  <social.icon size={18} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-slate-900 font-bold mb-4 text-xs font-display tracking-wider uppercase">
              Quick Links
            </h4>
            <ul className="space-y-2.5 text-sm">
              {['Services', 'Products', 'Portfolio', 'Manifesto', 'Contact'].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="text-slate-600 hover:text-purple-600 font-medium transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-slate-900 font-bold mb-4 text-xs font-display tracking-wider uppercase">
              Contact Us
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-600 font-medium">
              <li>{companyData.contact.email}</li>
              <li>{companyData.contact.phone}</li>
              <li>{companyData.contact.address}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500 space-y-4 md:space-y-0 font-medium">
          <p>© {currentYear} {companyData.name}. All rights reserved.</p>
          <div className="flex items-center space-x-6">
            <span className="flex items-center">
              Crafted with <Heart size={12} className="text-pink-500 mx-1 fill-pink-500" /> for modern web & 3D apps
            </span>
            <button
              onClick={scrollToTop}
              className="p-2 rounded-lg glass hover:text-purple-600 transition-colors shadow-sm"
              aria-label="Scroll to top"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
